import { useEffect } from "react";
import { SEO } from "../components/SEO";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { LegalMentions } from "../components/legal/LegalMentions";
import { LegalPrivacy } from "../components/legal/LegalPrivacy";

const LEGAL_TITLE =
    "Mentions légales et confidentialité — Données & Droit";
const LEGAL_DESCRIPTION =
    "Mentions légales du site donnees-et-droit.fr et politique de confidentialité applicable aux informations transmises via le formulaire de contact.";

function LegalHero() {
    return (
        <section
            className="border-b border-slate-200"
            data-testid="legal-hero"
        >
            <div className="mx-auto max-w-4xl px-6 md:px-12 lg:px-16 pt-20 md:pt-28 pb-12 md:pb-16">
                <h1
                    className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#0B132B] font-medium leading-[1.05]"
                    data-testid="legal-title"
                >
                    Mentions légales et confidentialité
                </h1>
                <p className="mt-6 text-base lg:text-lg text-slate-600 leading-relaxed max-w-2xl">
                    Cette page regroupe les mentions légales du site
                    donnees-et-droit.fr et la politique de confidentialité
                    applicable aux informations transmises par le formulaire
                    de contact.
                </p>
            </div>
        </section>
    );
}

export function LegalPage() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <main data-testid="legal-page">
            <SEO
                path="/mentions-legales-confidentialite"
                title={LEGAL_TITLE}
                description={LEGAL_DESCRIPTION}
            />
            <Header />
            <LegalHero />
            <LegalMentions />
            <LegalPrivacy />
            <Footer />
        </main>
    );
}
